"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AGENTIC_EXTRACTORS = exports.AgenticExtractorName = void 0;
exports.agenticExtractorUserId = agenticExtractorUserId;
exports.agenticExtractorUsername = agenticExtractorUsername;
exports.agenticExtractorDisplayName = agenticExtractorDisplayName;
exports.agenticExtractionBlobKey = agenticExtractionBlobKey;
var AgenticExtractorName;
(function (AgenticExtractorName) {
    AgenticExtractorName["Ade"] = "ade";
    AgenticExtractorName["Lde"] = "lde";
    AgenticExtractorName["Pu"] = "pu";
})(AgenticExtractorName || (exports.AgenticExtractorName = AgenticExtractorName = {}));
exports.AGENTIC_EXTRACTORS = {
    [AgenticExtractorName.Ade]: {
        displayName: 'Agentic Datasheet Extraction',
        currentVersion: 1,
    },
    [AgenticExtractorName.Lde]: {
        displayName: 'Locke Data Extraction',
        currentVersion: 1,
    },
    [AgenticExtractorName.Pu]: {
        displayName: 'Package Understanding Workflow',
        currentVersion: 1,
    },
};
const USER_ID_VERSION_DIGITS = 4;
const MAX_ENCODABLE_VERSION = 10 ** USER_ID_VERSION_DIGITS - 1;
function assertValidVersion(version) {
    if (!Number.isInteger(version) || version < 1) {
        throw new Error(`Invalid agentic extractor version: ${version}`);
    }
}
function agenticExtractorUserId(name, version) {
    assertValidVersion(version);
    if (version > MAX_ENCODABLE_VERSION) {
        throw new Error(`Agentic extractor version ${version} exceeds the id's ${USER_ID_VERSION_DIGITS}-digit field`);
    }
    const versionField = String(version).padStart(USER_ID_VERSION_DIGITS, '0');
    const suffix = `${name}v${versionField}`.toLowerCase().replace(/[^a-z0-9]/g, '');
    return `u_${suffix.padEnd(32, '0')}`;
}
function agenticExtractorUsername(name, version) {
    assertValidVersion(version);
    return `${name}-v${version}`;
}
function agenticExtractorDisplayName(name, version) {
    assertValidVersion(version);
    return `${exports.AGENTIC_EXTRACTORS[name].displayName} v${version}`;
}
function agenticExtractionBlobKey(packageId, name, version, runId) {
    assertValidVersion(version);
    return `packages/${packageId}/${name}/v${version}/${runId}/result.json`;
}
//# sourceMappingURL=agentic-extractor-registry.js.map